import { finish, error } from '../../../modules/postcode/actions/find';

import api from '../../../api';

export function request(dispatch, { postCode }) {
    api.get('/find-address', {
        postCode
    }, {
        cache: 5 * 1000,
        id: `find-address-${postCode}`
    }).then(
        ({ data }) => dispatch(finish(postCode, data)),
        ({ errors }) => dispatch(error(postCode, errors))
    );
}
